// @core/api/endpoints/notifications/get_user_settings_global.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetUserSettingsGlobalResponse,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Get user global notification settings
 * Retrieves the user's global notification preferences including quiet hours, preferred channels, and notification frequency settings.
 */
export async function GetUserSettingsGlobal(
  user_id: string,
  options?: RequestOptions
): Promise<GetUserSettingsGlobalResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/users/:user_id/settings`;
  requestPath = requestPath.replace(':user_id', encodeURIComponent(user_id));
  const requestOptions = options;
  return client.get<GetUserSettingsGlobalResponse>(requestPath, { ...requestOptions });
}
